import { Typography } from '@/components/typography/typography'
import { WithLabel } from '@/components/with-label/with-label'
import { cn } from '@/libs/tw'
import { translate } from '@/utils/translator'

type RoomSummaryProps = {
	adults: number
	type?: string
	children: number[]
	roomIndex: number
}

export const RoomConfigurationSummaryCard = ({
	adults,
	children,
	type,
	roomIndex,
}: RoomSummaryProps) => {
	return (
		<article
			className={cn(
				'flex w-full flex-col gap-24 border-t border-textColor bg-secondary pt-24 text-textColor',
				'md:rounded-8 md:border-none md:bg-roomConfiguration-summaryBackground md:p-24 md:pb-32 md:text-roomConfiguration-summaryText'
			)}
		>
			<div className={cn('flex justify-between')}>
				<Typography
					style="h3"
					element="h3"
				>{`${translate('room-config-room')} ${roomIndex}`}</Typography>
			</div>
			{type && (
				<div
					className={cn(
						'self-start rounded-24 border bg-roomConfiguration-summaryText px-16 py-6 capitalize text-white',
						'md:px-32 md:py-8'
					)}
				>
					{type}
				</div>
			)}

			<Typography style="p-bold" element="h4">
				{translate('room-config-amount-of-persons')}
			</Typography>
			<WithLabel label={translate('room-config-adults')} data-testId="test">
				<Typography style="p" element="p">
					{adults}
				</Typography>
			</WithLabel>
			<WithLabel label={translate('room-config-children')}>
				<Typography style="p" element="p">
					{children.length}
				</Typography>
			</WithLabel>
			{children.length > 0 && (
				<Typography style="p-bold" element="h4">
					{translate('room-config-children-age-departure')}
				</Typography>
			)}
			{children.map((childAge, index) => (
				<WithLabel key={index} label={`${translate('room-config-child')} ${index + 1}: `}>
					<Typography style="p" element="p">
						{childAge}
					</Typography>
				</WithLabel>
			))}
		</article>
	)
}
